<template>
    <div class="box">
        <div class="detailTitle">{{showMes.Title}}</div>
        <div class="detailMessage">
            <span>{{showMes.UpdateTime}}</span>
            <span>{{showMes.ViewCount}}阅读</span>
            <span>{{showMes.UpdateUser}}</span>
            <router-link :to="{ path: '/historyKnowledge',
                            query:{KnowledgeId:showMes.KnowledgeId} }">
                <div class="showAnotherColor">历史版本>></div>
            </router-link>
        </div>
        <div class="detailMessage">
            <span>知识分类:{{showMes.CategoryName}}</span>
            <span>知识来源:{{dataFormat(showMes.Origin)}}</span>
            <span>服务目录:{{showMes.ServiceName}}</span>
        </div>
        <p>
          <span>附件:</span>
          <span v-for="item in showMes.Attachment">
            <a class="showAnotherColor"  :href="item.url">{{item.name}}</a>&nbsp;&nbsp;
          </span>
        </p>
        <div class="changeBackground">
             <div v-if="loadingIcon" style="text-align: center;"><i class="el-icon-loading" style="font-size: 30px;"></i></div>
            <p v-else v-html="showMes.Body">{{showMes.Body}}</p>


        </div>
    </div>
</template>

<script>

    import services from "./knowledge.service";
    export default {
        data: function () {
            return {
                showMes:{},
                loadingIcon:true
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            //知识来源
            knowledgeDic(){
                return this.dictionary.KnowledgeOrigin;
            },
            // query:function () {
            //     return this.$route.query.rowData
            // },
            KnowledgeId:function () {
                return this.$route.query.KnowledgeId
            },
            Version:function () {
                return this.$route.query.Version
            },
            // pages(){
            //     return this.$store.state.tabView.pages
            // },
        },
        created(){

        },
        mounted(){
            // console.log(this.pages)
            // console.log(this.$route.query)
            // console.log(this.KnowledgeId)
            if(this.KnowledgeId){
                this.getDetail();
            }
        },
        methods:{
            dataFormat(val){
                let cname=''
                if(this.knowledgeDic.length>0){
                    this.knowledgeDic.map(item =>{
                        if(item.id == val){
                            cname=item.cname
                        }
                    })
                }

                return cname
            },
            getDetail(){
                // console.log(this.KnowledgeId,this.Version)
                services.knowledgeDetail({"KnowledgeId":this.KnowledgeId,"Version":this.Version}).then(res=>{

                    this.showMes = res;
                    this.loadingIcon=false
                })
            }
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .box{
        // margin-left: 20px;
        background: #ffffff;
        padding-left: 20px;
        box-sizing: border-box;
    }
    .detailTitle{
        font-size: 20px;
        margin: 20px 0;
    }
    .detailMessage{
        display: flex;
        margin-bottom: 20px;
        &>span:nth-child(2){
            margin-left: 30px;
        }
        &>span:nth-child(3){
            margin: 0 20px;
        }
    }
    .showAnotherColor{
        color:#1C86EE;
    }
</style>
